const Demos = () => {
  return (
    <>
      <div className="text-center py-10">
        <h2 className="from-[#a200be] to-[#246BFD] bg-gradient-to-tl text-7xl font-bold bg-clip-text text-transparent">
          FREE
        </h2>
        <h2 className="font-medium text-3xl py-4">Stunning Demos</h2>
        <ul className="flex max-w-[700px] mx-auto justify-between py-3">
          <li>
            <i className="fa-solid check fa-circle-check text-xl text-indigo-600 mr-3"></i>{" "}
            User Friendly
          </li>
          <li>
            <i className="fa-solid check fa-circle-check text-xl text-indigo-600  mr-3"></i>{" "}
            Easy to Use
          </li>
          <li>
            <i className="fa-solid check fa-circle-check text-xl text-indigo-600  mr-3"></i>{" "}
            Free Lifetime Update
          </li>
        </ul>
        <div className="flex flex-wrap gap-4 text-center justify-center py-4">
          <button className="bg-gradient-to-r from-violet-600 to-indigo-600 text-xl  rounded px-6 py-3 text-white">
            Fleet Demo
          </button>
          <button className="border border-indigo-600 rounded px-6 py-3 from-[#a200be] to-[#246BFD] bg-gradient-to-tl text-xl bg-clip-text text-transparent">
            ELD Demo
          </button>
        </div>
      </div>
    </>
  );
};
export default Demos;
